import React from "react";
import { Outlet } from "react-router-dom";
import AimoHeader from "../components/AimoHeader";
import Footer from "../components/Footer";
import { StepProvider } from "../contexts/StepContext";
import "../App.css";
import { StyledEngineProvider } from "@mui/material";

function OrderConfirmedLayout() {
  return (
    <div className="App">
      <StyledEngineProvider injectFirst>
        <StepProvider>
          <div className="flexWrapper">
            <div>
              <AimoHeader />
              <Outlet />
            </div>
            <Footer />
          </div>
        </StepProvider>
      </StyledEngineProvider>
    </div>
  );
}

export default OrderConfirmedLayout;
